export default [
  { key: '0/50000', val: '$0 - $500 CAD' },
  { key: '50000/100000', val: '$500 - $1,000 CAD' },
  { key: '100000/500000', val: '$1,000 - $5,000 CAD' },
  { key: '500000/1000000', val: '$5,000 - $10,000 CAD' },
  { key: '1000000/5000000', val: '$10,000 - $50,000 CAD' },
  { key: '5000000/*', val: '$50,000 CAD + ' }
];
